// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1POuW","addWidgetButton":"Header_addWidgetButton__1-jEf","dashboardTabs":"Header_dashboardTabs__hIGlo","active":"Header_active__3dfk2"};